export default __webpack_public_path__ + "static/media/profile.42ac5c34.svg";